export default function title(...topics: string[]) {
  return [...topics, "Bokahundtrim"].join(" · ");
}
